import React from "react";
import PropTypes from "prop-types";
import CheckBox from "components/CheckBox";
import termsAndCondition from "assets/images/datafarming-terms-and-condition.pdf";
import "./index.scss";

const Terms = ({ termsAccepted, setTermsAccepted }) => {
  return (
    <div className="payment-terms">
      <CheckBox
        checked={termsAccepted}
        onChange={() => setTermsAccepted(!termsAccepted)}
      />
      <p>
        I agree with the new Datafarming{" "}
        <a
          className="link"
          href={termsAndCondition}
          target="_blank"
          rel="noreferrer"
        >
          Terms and Conditions.
        </a>
      </p>
    </div>
  );
};

Terms.propTypes = {
  termsAccepted: PropTypes.bool.isRequired,
  setTermsAccepted: PropTypes.func.isRequired,
};

export default Terms;
